import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PublishedComponent, ControlledField } from "@openimis/fe-core";
import { fetchShehiaGenderReport } from "../actions";

const cardStyle = {
  flex: 1,
  padding: 20,
  margin: 10,
  borderRadius: 10,
  color: "#fff",
  textAlign: "center",
  fontSize: 18,
  fontWeight: "bold",
};

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  marginTop: 20,
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: 20,
};

const thtd = {
  border: "1px solid #ddd",
  padding: 10,
  textAlign: "left",
};

const paginationStyle = {
  marginTop: 15,
  display: "flex",
  justifyContent: "center",
  gap: 10,
};

const IndividualReportPage = () => {
  const dispatch = useDispatch();

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [recordsPerPage] = useState(5);

  // ✅ Correct selectors (insuree reducer)
  const reportFromState = useSelector(
    (state) => state.insuree.insureeShehiaGenderReport
  );
  const fetchingReport = useSelector((state) => state.insuree.fetchingReport);
  const errorReport = useSelector((state) => state.insuree.errorReport);

  const report = Array.isArray(reportFromState) ? reportFromState : [];

  const totalMembers = report.reduce((s, r) => s + (r.total || 0), 0);
  const maleMembers = report.reduce((s, r) => s + (r.male || 0), 0);
  const femaleMembers = report.reduce((s, r) => s + (r.female || 0), 0);

  const indexOfLast = page * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = report.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(report.length / recordsPerPage) || 1;

  const onChangeFilters = (updates) => {
    setFilters((prev) => {
      const next = { ...prev };
      updates.forEach((u) => {
        if (u.value == null) delete next[u.id];
        else next[u.id] = { value: u.value };
      });
      return next;
    });
  };

  const loadReport = () => {
    const location = filters.parentLocation?.value;
    if (!location) {
      alert("Please select location");
      return;
    }

    const getLevelFromType = (type) => {
      switch (type) {
        case "R": return 0;
        case "D": return 1;
        case "W": return 2;
        case "V": return 3;
        default: return 1;
      }
    };

    const level = getLevelFromType(location.type);

    dispatch(
      fetchShehiaGenderReport(level, location.uuid, "2010-01-01", "2026-12-31")
    );

    setPage(1);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Shehia Gender Report</h2>

      {/* Summary Cards */}
      <div style={containerStyle}>
        <div style={{ ...cardStyle, backgroundColor: "#1976d2" }}>
          Total Members
          <h1>{totalMembers}</h1>
        </div>
        <div style={{ ...cardStyle, backgroundColor: "#2e7d32" }}>
          Male Members
          <h1>{maleMembers}</h1>
        </div>
        <div style={{ ...cardStyle, backgroundColor: "#8e24aa" }}>
          Female Members
          <h1>{femaleMembers}</h1>
        </div>
      </div>

      {/* Location Filter */}
      <div style={{ marginTop: 20, display: "flex", gap: "20px", alignItems: "flex-end", flexWrap: "wrap" }}>
        <div style={{ width: 350 }}>
          <ControlledField
            module="insuree"
            id="IndividualReportPage.location"
            field={
              <PublishedComponent
                pubRef="location.DetailedLocationFilter"
                withNull={true}
                filters={filters}
                onChangeFilters={onChangeFilters}
                anchor="parentLocation"
              />
            }
          />
        </div>

        <button
          onClick={loadReport}
          style={{
            padding: "10px 20px",
            backgroundColor: "#2196f3",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Load Report
        </button>
      </div>

      {/* Feedback */}
      {fetchingReport && <p style={{ marginTop: 20, fontStyle: "italic" }}>Loading report...</p>}
      {errorReport && <p style={{ marginTop: 20, color: "red" }}>Error: {errorReport}</p>}

      {/* Table */}
      <table style={tableStyle}>
        <thead>
          <tr style={{ backgroundColor: "#f5f5f5" }}>
            <th style={thtd}>#</th>
            <th style={thtd}>Shehia</th>
            <th style={thtd}>Male</th>
            <th style={thtd}>Female</th>
            <th style={thtd}>Total</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.length > 0 ? (
            currentRecords.map((r, i) => (
              <tr key={i}>
                <td style={thtd}>{indexOfFirst + i + 1}</td>
                <td style={thtd}>{r.shehiaName}</td>
                <td style={thtd}>{r.male}</td>
                <td style={thtd}>{r.female}</td>
                <td style={thtd}>{r.total}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ ...thtd, textAlign: "center" }}>
                No data available. Select location and click Load.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {report.length > 0 && (
        <div style={paginationStyle}>
          <button disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
          <span>Page {page} of {totalPages}</span>
          <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}
    </div>
  );
};

export default IndividualReportPage;
